import React from 'react';
import PropTypes from 'prop-types';

const Page = ({ heroComponent: HeroComponent, paddingTop, children }) => {
  return (
    <div className={paddingTop ? 'pt-24 md:pt-32' : ''}>
      {
        HeroComponent
          ? <div className="w-screen">
              <HeroComponent />
            </div>
          : null
      }
      <div className="container mx-auto px-4 mb-8">
        { children }
      </div>
    </div>
  );
};

Page.propTypes = {
  paddingTop: PropTypes.bool,
};

Page.defaultProps = {
  paddingTop: true,
};

export default Page;
